import { render, staticRenderFns } from "./DetailsSchedule.vue?vue&type=template&id=4e95fbca&scoped=true"
import script from "./DetailsSchedule.vue?vue&type=script&lang=js"
export * from "./DetailsSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e95fbca",
  null
  
)

export default component.exports